/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import AppContext from "../Utils/appContext";
import { useNavigate } from "react-router-dom";
import ProductLoader from "./Common/ProductLoader";
import { extractIdFromGid } from "../Utils/categories-divide";
import { getProductsByCategoryId } from "../Utils/api-service";
import ProductAutoScroll from "./ProductAutoScroll";
import { vibrate } from "../Utils/util-service";
import RichTitle from "./RichTitle";

function NewCategory() {
  const navigate = useNavigate();
  const { otherCategories, showPrice } = React.useContext(AppContext);
  const [categories, setCategories] = React.useState([]);
  const [products, setProducts] = React.useState({});
  const [categoriesId, setCategoriesId] = React.useState();
  const [loading, setLoading] = React.useState({});

  React.useEffect(() => {
    if (otherCategories.length > 0) {
      const arr = [];
      const catIds = [];
      otherCategories.forEach((cat, indx) => {
        arr[indx] = cat;
        const [, title] = cat?.title.split("__");
        arr[indx]["mainTitle"] = title;
        const id = extractIdFromGid(cat?.id);
        arr[indx]["mainId"] = id;
        catIds.push(id);
      });
      setCategories(arr);
      setCategoriesId(catIds);
    }
  }, [otherCategories]);

  React.useEffect(() => {
    if (categoriesId) {
      fetchProducts(categoriesId);
    }
  }, [categoriesId]);

  const fetchProducts = (ids) => {
    ids.forEach((id) => {
      setLoading((prevLoadings) => ({
        ...prevLoadings,
        [id]: true,
      }));
      try {
        let nextCursor;
        let res = getProductsByCategoryId(id, nextCursor);
        res.then((data) => {
          if (data.status === 200) {
            const ps = data?.data?.collection?.products?.nodes || [];
            setLoading((prevLoadings) => ({
              ...prevLoadings,
              [id]: false,
            }));
            setProducts((prevProducts) => ({
              ...prevProducts,
              [id]: ps,
            }));
          }
        });
      } catch (error) {
        setLoading((prevLoadings) => ({
          ...prevLoadings,
          [id]: false,
        }));
        console.error("Error fetching data:", error);
      }
    });
  };

  const goTo = (category) => {
    vibrate(20);
    return navigate(
      "/product-list?categoryName=" +
        category.mainTitle +
        "&categoryId=" +
        category?.mainId,
    );
  };

  const goToProduct = (id) => {
    const productId = extractIdFromGid(id);
    vibrate(20);
    navigate("/product?productId=" + productId);
  };

  return (
    <>
      {categories?.map((category, indx) => {
        return (
          <div key={indx}>
            <section className="deals-section px-15 pt-0">
              <div className="title-part">
                <h2>
                  <RichTitle
                    segments={category.richTitleSegments}
                    fallback={category?.mainTitle}
                  />
                </h2>
                <a className="see-all-link" onClick={() => goTo(category)}>
                  See All
                </a>
              </div>
              {loading?.[category?.mainId] && <ProductLoader />}
              {!loading?.[category?.mainId] && (
                <ProductAutoScroll
                  products={products?.[category?.mainId] || []}
                  showPrice={showPrice}
                  onProductClick={goToProduct}
                  badgeFallback={<></>}
                  showWishlist
                  wishlistSource="CATEGORY"
                />
              )}
            </section>
            <div className="divider"></div>
          </div>
        );
      })}
    </>
  );
}

export default NewCategory;
